import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "今日热榜", to: "/rank" },
  { label: "分类速览", to: "/#categories" },
  { label: "关于我们", to: "/about" },
];

const hotKeywords = ["大结局口碑", "直播回应", "折叠屏定价", "夜跑报名", "加时绝杀"];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="w-full bg-foreground-950 text-background-50">
        <div className="flex w-full flex-wrap items-center gap-x-4 gap-y-1 px-4 py-1.5 text-xs md:px-8">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-400 animate-pulse-soft" />
            榜单每小时刷新
          </span>
          <span className="hidden h-3 w-px bg-background-50/25 sm:block" />
          <div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-3 gap-y-1 text-background-50/75">
            {hotKeywords.map((word) => (
              <Link
                key={word}
                to="/rank"
                className="cursor-pointer whitespace-nowrap transition-colors hover:text-accent-300"
              >
                # {word}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="flex w-full items-center gap-4 px-4 py-3 md:px-8 md:py-4">
          <Link to="/" className="flex cursor-pointer items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg leading-none" aria-hidden="true" />
            </span>
            <span className="flex flex-col leading-tight">
              <span className="heading-font text-lg font-black tracking-tight text-foreground-950">
                瓜田热榜
              </span>
              <span className="hidden text-[11px] text-foreground-500 sm:block">
                全网热议话题聚合
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="ml-6 hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.label}
                to={item.to}
                className={({ isActive }) =>
                  `cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                    isActive && !item.to.includes("#")
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <Link
              to="/rank"
              className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 sm:flex"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-search-line text-base leading-none" aria-hidden="true" />
              </span>
              找话题
            </Link>
            <Link
              to="/rank"
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              看今日榜
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true" />
              </span>
            </Link>
            <button
              type="button"
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
            </button>
          </div>
        </div>

        {menuOpen && (
          <nav aria-label="移动端导航" className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <ul className="flex flex-col gap-1">
              {navItems.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="flex cursor-pointer items-center justify-between rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
                  >
                    {item.label}
                    <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                      <i className="ri-arrow-right-s-line text-lg leading-none" aria-hidden="true" />
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
}